import { Store } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux'
import type { AppDispatch, RootState } from '../store'
import useTabTitle from './useTabTitle'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
// Reads state without subscribing — for one-off lookups inside callbacks, where a
// selector would only add a re-render source (or hand back a stale render-time value).
export const useAppStore = useStore.withTypes<Store<RootState>>()

// Export custom hooks
export { useTabTitle }
export { useGTM } from './useGTM'
export { useMetaPixel } from './useMetaPixel'
export { useLatestRef } from './useLatestRef'
